import { assertNotEmpty, type Compare } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { TemplateVersion } from '../../types/templateModel'
import { ComparableDocumentationDiff } from './ComparableDocumentationDiff'
import { ComparableTemplateDiff } from './ComparableTemplateDiff'
import { DiffPopoverLayout } from './DiffPopoverLayout'
import { TemplateFieldDiffHeader } from './TemplateFieldDiffHeader'
import { useCompareContext } from './valueSetupCompareContext'

export const TemplateVersionDiff = ({
  current,
  compare,
}: Compare<TemplateVersion>) => {
  const translate = useTranslate()
  const { shouldCompare } = useCompareContext()
  assertNotEmpty(current)

  return (
    <DiffPopoverLayout>
      <div className="mb-8 grid grid-cols-2 gap-x-24">
        <TemplateFieldDiffHeader
          current={current?.origin}
          compare={compare?.origin}
        />
      </div>
      <div className="flex flex-col gap-y-4">
        {shouldCompare('documentation') && (
          <ComparableDocumentationDiff
            current={current?.documentation?.value}
            compare={compare?.documentation?.value}
          />
        )}
        {shouldCompare('parentId') && (
          <ComparableTemplateDiff
            title={translate('diffPopover.templateVersion.parent')}
            current={current?.versionInfo.parentId}
            compare={compare?.versionInfo.parentId}
          />
        )}
        {shouldCompare('replaces') && (
          <ComparableTemplateDiff
            title={translate('diffPopover.templateVersion.replaces')}
            current={current?.replaces}
            compare={compare?.replaces}
          />
        )}
      </div>
    </DiffPopoverLayout>
  )
}
